import { IAPIResponse } from './../../shared/config';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { WeGoConfig } from "../../shared/config";
import { AuthService } from "../../shared/models/auth.service";
import { Http, Response, Headers, RequestOptions } from '@angular/http';


// Refer from https://stackoverflow.com/questions/35985347/how-to-upload-file-in-angular2


@Injectable()
export class BrandingService {
  constructor(private authService: AuthService
    , private http: Http) { }

  public GetBranding(instanceHashId: string, companyHashId: string): Observable<IAPIResponse> {
    let getBrandingUrl = WeGoConfig.API_GET_BRANDING;
    getBrandingUrl = getBrandingUrl + "?instanceHashId=" + instanceHashId
      + "&companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getBrandingUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UploadBranding(formData: FormData): Observable<IAPIResponse> {
    return Observable.create((observer: any) => {
      let url: string = WeGoConfig.API_POST_UPDATE_BRANDING;
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      let header = this.authService.GetHeaderForFile();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            console.log(xhr.response);
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.status);
            //this.authService.HandleAPIError(xhr.response.status)
          }
        }
      };

      xhr.open('POST', url, true);
      for (let i = 0; i < header.length; i++) {
        xhr.setRequestHeader(header[i]['name'], header[i]['value']);
      }
      xhr.send(formData);
    });
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/branding/models/branding.service.ts